.th:last-child {
  width: 200px;
}

.pointer {
  cursor: pointer;
}

.tableScrollContainer {
  background-image:
    linear-gradient(to right, var(--mantine-color-body) 30%, transparent),
    linear-gradient(to left, var(--mantine-color-body) 30%, transparent),
    linear-gradient(to right, rgba(0, 0, 0, 0.08), transparent),
    linear-gradient(to left, rgba(0, 0, 0, 0.08), transparent);
  background-position:
    left center,
    right center,
    left center,
    right center;
  background-size:
    40px 100%,
    40px 100%,
    16px 100%,
    16px 100%;
  background-attachment: local, local, scroll, scroll;
  background-repeat: no-repeat;
}
